<template>
  <el-dialog :title="newtitle" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="handleClose">
    <div class="dialogDatapro" id="dialogDatapro">
      <div style="display: flex;flex-direction: column;height: 100%;">
        <div class="bg">
          <div class="history_list_title bg">
            <div>{{$t('colon.orderNumber')}}<em>{{orderList.Code}}</em></div>
            <router-link class="avatar_box" :to="{path:'/seller/detail/'+orderList.ReceiveUserID}" target="_blank">
              <el-avatar class="avatar" :src="orderList.StoreLogo"></el-avatar>
              <em ref="ifEarth">{{orderList.SellerName}}</em>
            </router-link>
          </div>
          <div class="commodity_index_box">
            <router-link :to="{path:'/mycardhobby/detail/'+orderList.ID}" target="_blank">
              <div class="commodity_img">
                <img :src="orderList.Details?orderList.Details[0].TitImg:''">
                <span v-if="orderList.Details&&orderList.Details.length>1">{{orderList.Details.length}} {{$t('base.items')}}</span>
              </div>
            </router-link>
            <div class="commodity_index">
              <h1 class="color_333 commodity_title line_txt3">
                <router-link :to="{path:'/mycardhobby/detail/'+orderList.ID}" target="_blank">
                  {{orderList.Details?orderList.Details[0].Title:''}}</router-link>
              </h1>
              <div class="Process_box"><!-- {{orderList.Details?orderList.Details[0].RealLowestPrice:''}} -->

                <div class="Order_price color_333">{{$t('colon.orderTotal')}} <span>{{areaSymbol}} {{PostageMoney(orderList)}}</span>
                </div>
                <div class="Process color_333" v-if="progress.SRBtnType>0" @click="ChangeSRBtnType(progress.SRBtnType)">
                  {{SRBtnType(progress.SRBtnType)}}</div>
                <!-- <div class="Process color_333" style="border:none;" v-else >
                    {{SRBtnType(progress.SRBtnType)}}</div>  -->
                <div class="Process color_333" :class="progress.SRStatus == 3 ? 'color_aoao':'color_333'" @click="noClick"
                  v-if="progress.SRStatus>=2&&progress.SRBtnType==0">
                  {{progress.SRStatus ==2?$t('base.completed'):$t('base.caseClosed')}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pro_list">
          <div v-for="(res,i) in progress.objs" :key="i">
            <span class="title_color1 time">{{ res.CreateDate|setTime }}</span>
            <!-- <span class="title_color1 time">{{res.CreateDate|setTimeSSS}}</span> -->
            <div :class="[res.SRUserID==userInfo.Id||res.SRUserID==userInfo.MappingUserId?'user_reply':'seller_reply']">
              <img :src="res.SRUserImage+'?imageView2/2/w/350'">
              <div :class="[res.SRUserID==userInfo.Id||res.SRUserID==userInfo.MappingUserId?'user_reply_box':'seller_reply_box']">
                <span v-if="res.SRUserID!=userInfo.Id&&res.SRUserID!=userInfo.MappingUserId" class="most"></span>
                <div class="text">
                  <span>{{res.Title}}</span>
                  <div class="text_img reply" v-if="res.Images">
                    <swiper class="swiper" :options="swiperOption">
                      <swiper-slide class="like_slide" v-for="(img,k) in res['Images']" :key="k">
                        <el-image class="like_img" style="height: 88px;object-fit: contain;" :src="img+'?imageView2/2/w/350'"
                          fit="contain" :preview-src-list="res.Images">
                        </el-image>
                      </swiper-slide>
                    </swiper>
                  </div>
                </div>
                <span v-if="res.SRUserID==userInfo.Id||res.SRUserID==userInfo.MappingUserId" class="most"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog_footer" style="margin: 0;">
      <div class="send_box" v-if="progress.SRStatus <= 1">
        <div class="img-block">
          <upload-images ref="UploadImages" uploadType="small"></upload-images>
        </div>
        <div class="text">
          <el-input type="textarea" @input.native="inputlength" :rows="2"
            :placeholder="$t('alert.describeRequest')" v-model="EquityVal" maxlength="150"></el-input>
          <div class="f_button">
            <el-button type="primary" ref="send_b" :disabled='disabled' class="send" @click="EquitySave">{{ $t('base.send') }}</el-button>
          </div>
          <!-- <el-popover placement="top" width="160" v-model="visible">
              <el-alert title="错误提示的文案" type="error" @change="visible=false">
              </el-alert>
              <div style="width:100%;display: flex;position: relative;padding-top:10px;">
                <el-button slot="reference" type="primary" class="send" @click="EquitySave">Send</el-button>
              </div>
            </el-popover> -->
        </div>
      </div>
      <div v-else>
        <el-button type="primary iffinish" @click="handleClose">Done</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>

import { getTime,numAdd, numMulti,isNumber,priceExchange} from "@/api/public";
import UploadImages from '@/components/upload-images'
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import qs from 'qs'
export default {
  name: '',
  data() {
    return {
      areaSymbol: this.$store.state.areaSymbol,
      swiperOption: {
        slidesPerView: 'auto',
        // spaceBetween: 19,
      },
      newtitle: this.title,
      oid: '',
      orderList: '',
      progress: {},
      EquityVal: '',
      imgs: [],
      disabled: false,
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    UploadImages,
  },
  props: {
    dialogClass: '',
    title: "",
    domVisible: Boolean,
    list: {},
    userInfo: {}
  },
  watch: {},
  filters: {
    setTime(val) {
      return getTime(val, -8, '', 'cn')
    },

  },
  created() {
    this.oid = this.list.RelationID ? this.list.RelationID : this.list.ID;
    this.GetOrderDetail()
  },
  computed: {
    SRBtnType: function(){
      var that = this;
      return (type) => {
        /*
        srBtnType = 1    显示撤销维权的按钮        srBtnType = 2    显示重新维权的按钮
        srBtnType = 3    显示提起申诉的按钮        srBtnType = 4    显示撤销申诉的按钮
        */
        let btnval = this.$t('base.processing');
        switch (type) {
          case 1:
            btnval = this.$t('base.revoke');
            break;
          case 2:
            btnval = this.$t('base.openCase');
            break;
          case 3:
            btnval = this.$t('base.openCase');
            break;
          case 4:
            btnval = this.$t('base.revoke');
            break;
        }
        return btnval
      }
    }
  },
  methods: {

    //价格加法，obj:传入的obj,type:判断是邮费还是总价，0:邮费、1:总价
    PostageMoney(obj) {
      console.log(obj,'111')
      let isRealPostageMoney = obj.RealPostageMoney != null ? true : false
      let price = 0
        if (isRealPostageMoney) {
          price = numAdd(isNumber(obj.RealLowestPrice), isNumber(obj.RealPostageMoney))
        } else {
          price = isNumber(obj.USD_TotalPrice)
        }
        if (obj.OrderType != 1) {
          //var Service=numAdd(priceExchange(obj.ServiceFee,'USD'), priceExchange(obj.TaxPrice,'USD'))
          //var Service=numAdd(isNumber(obj.ServiceFeeUsd), isNumber(obj.TaxPriceUsd))

          var Service = 0
          if (obj.ServiceFeeUsd) {
            Service = numAdd(isNumber(obj.ServiceFeeUsd), isNumber(obj.TaxPriceUsd))
      console.log(Service,'1')
          } else if (obj.ExchangeRate) {
            // Service = numAdd(numMulti(obj.ServiceFee, obj.ExchangeRate), numMulti(obj.TaxPrice, obj.ExchangeRate))
            Service = numAdd(obj.ServiceFee, obj.TaxPrice)
      console.log(Service,'2')
          } else {
            Service = numAdd(priceExchange(obj.ServiceFee, 'USD'), priceExchange(obj.TaxPrice, 'USD'))
      console.log(Service,'3')
          }
          price = numAdd(isNumber(price), isNumber(Service))
        }

        return price.toLocaleString()
  },
    handleClose() {

      this.$emit('closeDialog', 'safeguard', false)
    },
    // 获取订单详情用来改地址
    GetOrderDetail() {
      let that = this
      let data = { operator_id: that.userInfo.MappingUserId, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, orderId: this.oid }
      this.$get(this.$interface.OrdersDetail, data).then(res => {
        if (res.result != 0) {
          let result = res.data
          if (result.SRStatus > 1) {
            that.dialogClass = "dialogBoxPro pro if_footer"
          }
          this.areaSymbol=result.RealLowestPriceUnit
          this.orderList = result;
        }
        this.GetSafeRights()
      })
    },
    //获取维权详细
    GetSafeRights() {
      let that = this;
      let data = { orderId: this.oid, pageIndex: 1, applyType: 0, token: that.userInfo.ChineseToken, memberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId }
      this.$get(this.$interface.GetSafeRights, data).then(res => {
        if (res.result != 0) {
          let _data = res.data;
          _data['objs'] = _data['objs'].reverse()
          that.progress = _data
          // that.$set(that.progress, 'SRBtnType', _data.SRBtnType);
          // that.$set(that.progress, 'SRStatus', _data.SRStatus);
          // that.$set(that.progress, 'StatusMsg', _data.StatusMsg);
          // that.$set(that.progress, 'SRResult', _data.SRResult);
          // that.$set(that.progress, 'objs', _data['objs'].reverse());

          let s = that.progress.SRBtnType == 0 ? that.$t('base.openCase') : (that.progress.SRStatus == 1 ? that.$t('base.disputing') : that.$t('base.disputed'));
          this.newtitle = s || that.$t('base.detail');
          this.ChangeHeight()
        }
      })
    },
    noClick() {
      this.$message.warning(this.$t('alert.safeguardFinish'));
    },
    //获取输入长度
    inputlength({ target }) {
      const that = this
      that.EquityVal = target.value
      // console.log(22,this.EquityVal.length)
      if (this.EquityVal.length > 5) {
        this.$refs.send_b.$el.style.background = '#5F6DAE'
      } else {
        this.$refs.send_b.$el.style.background = '#afb6d7'
      }
    },
    EquitySave() {
      /*维权*/
      let that = this;
      that.disabled = true
      let _imageUrl = that.$refs.UploadImages.picList;
      // let imgs = '';
      if (_imageUrl.length) {
        _imageUrl.map((obj, k) => {
          // let cut = k < _imageUrl.length - 1 ? ',' : '';
          // that.imgs += obj['ImageUrl'] + cut;
          that.imgs.push(obj['ImageUrl']);
        });
      }
      var data = { OrderID: this.oid, Title: that.EquityVal, Images: that.imgs, token: that.userInfo.ChineseToken, memberId: that.userInfo.MappingUserId, operator_id: that.userInfo.MappingUserId, appname: "CardSeller" }
      this.$post(this.$interface.AddSafeRight, qs.stringify(data)).then(res => {
        console.log("axios-res:", res);
        let _type = 'success';
        that.GetSafeRights()
        if (res.result != 1) {
          _type = 'error';
          that.disabled = false
          that.$message({
            showClose: true,
            message: res.msg || _type,
            type: _type,
          });
        } else {
          // that.$message({
          //   showClose: true,
          //   message: "成功",
          //   message: res.msg || _type,
          //   type: _type,
          // });
          setTimeout(() => {
            that.$refs.UploadImages.picList = [];
            that.EquityVal = '';
            that.imgs = '';
            that.disabled = false
            this.$refs.send_b.$el.style.background = '#afb6d7'
            //that.OfferShow = false;
          }, 1000);
          //that.handleClose()
          //that.dialogVisible = false
        }
      })
        .catch((err) => {
          that.disabled = false
          that.handleClose()
          console.log(err);
        });

    },
    //维权 更改维权状态 请求
    srTypeRequest(api, data) {
      let that = this;
      this.$post(api, qs.stringify(data)).then(res => {
        if (res.result) {
          that.GetSafeRights();
          // that.$message({
          //   showClose: true,
          //   message: res.msg || 'Success',
          //   type: 'success',
          // });
        }
      })
        .catch((err) => {
          console.log(err);
        });

    },//维权 更改维权状态
    ChangeSRBtnType(type) {
      let that = this;
      let api = ''
      console.log('type', type)
      let data = { OrderID: this.oid, memberid: that.userInfo.MappingUserId, token: that.userInfo.ChineseToken, operator_id: that.userInfo.MappingUserId }
      switch (type) {
        case 1:
          api = this.$interface.CancelSafrRight;
          break;
        case 2:
          api = this.$interface.ReOpenSafeRight;
          break;
        case 3:
          api = this.$interface.AppealSafrRight;
          break;
        case 4:
          api = this.$interface.CancelSafrRight;
          break;
      }
      if (type == 1 || type == 4) {
        that.$confirm(that.$t('alert.revokeSafeguard'), that.$t('base.revoke'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: that.$t('base.yes'),
          cancelButtonText: that.$t('base.no'),
        }).then(() => {
          // Yes
          that.srTypeRequest(api, data);
          if (type == 1) {
            that.$message({
              showClose: true,
              message: that.$t('alert.revokedSafeguard'),
              type: 'success',
            });
          }
          // console.log(111, data)
        }).catch(() => {
          // No
        });
      } else {
        that.srTypeRequest(api, data);
        that.$message({
          showClose: true,
          message: that.$t('alert.caseReopen'),
          type: 'success',
        });
      }
    },
    //根据状态改变高度
    ChangeHeight() {
      var parentN = document.getElementById('dialogDatapro').parentNode;
      var foorter = document.getElementsByClassName('el-dialog__footer')[0];
      if (this.progress.SRStatus > 1) {
        parentN.style.height = 'calc( 90vh - 53px)'
        foorter.style.display = 'none'
      }
      else {
        parentN.style.height = 'calc( 90vh - 204px)'
        foorter.style.display = 'block'
      }
    },
     //价格加法，obj:传入的obj,type:判断是邮费还是总价，0:邮费、1:总价
    PostageMoney(obj) {
      console.log(obj,'111')
      let isRealPostageMoney = obj.RealPostageMoney != null ? true : false
      let price = 0
        if (isRealPostageMoney) {
          price = numAdd(isNumber(obj.RealLowestPrice), isNumber(obj.RealPostageMoney))
        } else {
          price = isNumber(obj.USD_TotalPrice)
        }
        if (obj.OrderType != 1) {
          //var Service=numAdd(priceExchange(obj.ServiceFee,'USD'), priceExchange(obj.TaxPrice,'USD'))
          //var Service=numAdd(isNumber(obj.ServiceFeeUsd), isNumber(obj.TaxPriceUsd))

          var Service = 0
          if (obj.ServiceFeeUsd) {
            Service = numAdd(isNumber(obj.ServiceFeeUsd), isNumber(obj.TaxPriceUsd))
      console.log(Service,'1')
          } else if (obj.ExchangeRate) {
            // Service = numAdd(numMulti(obj.ServiceFee, obj.ExchangeRate), numMulti(obj.TaxPrice, obj.ExchangeRate))
            Service = numAdd(obj.ServiceFee, obj.TaxPrice)
      console.log(Service,'2')
          } else {
            Service = numAdd(priceExchange(obj.ServiceFee, 'USD'), priceExchange(obj.TaxPrice, 'USD'))
      console.log(Service,'3')
          }
          price = numAdd(isNumber(price), isNumber(Service))
        }

        return price.toLocaleString()
  },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/historylist.css";
/deep/ .pro {
  margin-top: -10vh;
}

/deep/ .dialogBoxPro {
  margin-top: 13vh;
}

/deep/ .el-dialog__wrapper {
  overflow: visible;
}

/deep/ .done_body {
  height: 82%;
}

/deep/ .pro .el-dialog__body {
  padding: 12px;
  background: #f7f7f7;
  /* height: calc( 90vh - 114px); */
  /* height: calc( 90vh - 194px); */
}

/deep/ .pro.if_footer .el-dialog__body {
  height: 82%;
}

/deep/.text .el-textarea__inner {
  border: none;
  height: 32px;
  padding: 0;
}

.if_footer {
  height: 83%;
}

.bg {
  background: #fff;
}

.like_slide {
  width: auto;
  max-width: 88px;
  height: 88px;
  margin-right: 19px;
}
.swiper-wrapper .like_slide:last-child{
  margin-right: 0;
}
.img-block {
  padding-bottom: 5px;
}

.title_color1 {
  color: #a0a0a0;
}

.time {
  text-align: center;
  width: 100%;
  display: block;
  padding: 16px 0;
}

.pro_list {
  height: 100%;
  overflow-y: scroll;
  margin: 8px 0 0;
}

.commodity_index_box,
.Process_box,
.seller_reply,
.user_reply {
  display: flex;
}

.commodity_index_box {
  padding: 12px;
  padding-top: 0;
}

.Process_box {
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
}

.commodity_index {
  position: relative;
  padding: 0 12px;
  width: 396px;
}

.commodity_img {
  width: 88px;
  height: 88px;
  border-radius: 3px;
  position: relative;
}

.commodity_img span {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  width: 90%;
  padding: 1px 5%;
  text-align: center;
}

.commodity_img img {
  width: 88px;
  height: 88px;
  border-radius: 3px;
  object-fit: contain;
}

.commodity_title {
  font-size: 16px;
  font-weight: 500;
}

.Order_price {
  height: 32px;
  font-size: 12px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}

.Process {
  height: 32px;
  font-size: 12px;
  padding: 9px 12px;
  display: inline-block;
  border: 1px solid #c8c8c8;
  border-radius: 4px;
  cursor: pointer;
}

.Processing_box {
  height: 100%;
  overflow-y: scroll;
  margin: 8px 0 0;
}

.seller_img {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.seller_reply img,
.user_reply img {
  width: 32px;
  height: 32px;
  border-radius: 4px;
}

.seller_reply,
.user_reply {
  margin: 0 0 16px 0;
}

.seller_reply .text,
.user_reply .text {
  min-height: 40px;
  max-width: 332px;
  background: #ffffff;
  z-index: 2;
  margin: 0 0 0 -6px;
  padding: 0 12px;
  display: flex;
  align-items: center;
}

.text span {
 /* padding: 12px 0;*/
  line-height: 1;
}

.most {
  width: 12px;
  height: 12px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  content: "";
  border-left: 0;
  border-top: 0;
  z-index: 1;
  margin: 12px 0;
}

.seller_reply_box {
  min-height: 40px;
  display: flex;
  margin: 0 0 0 10px;
}

.user_reply_box {
  display: flex;
  min-height: 40px;
  margin: 0 10px 0 0;
}

.user_reply_box .most {
  width: 12px;
  height: 12px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  content: "";
  border-left: 0;
  border-top: 0;
  z-index: 1;
  margin: 12px 0px 12px -6px;
}

.text img {
  width: 100px;
  height: 100px;
  border-radius: 4px;
  margin: 0 4px 0 0;
}

.text_img {
  max-height: 100px;
  padding: 0 0 12px 0;
}

.user_reply {
  justify-content: end;
  flex-direction: row-reverse;
}

.send {
  background: #afb6d7;
  color: #fff;
  border: none;
  /* position: absolute;
  right: 0; */
}

.send_box {
  /* padding: 0 12px 0 0; */
  background: #ffffff;
  /* position: relative; */
}

.offerEquity-box {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.dialogDatapro {
  height: 100%;
  background: #f7f7f7;
}

.pro_list_detail > div {
  display: flex;
  margin: 10px auto;
}

.pro_list_detail > div .like_box {
  display: flex;
}

.pro_list_detail > div .like_img {
  width: 88px;
  height: 88px;
  background-color: #f7f7f7;
  border-radius: 3px;
  margin-right: 12px;
}

.track_box_dialog {
  height: 300px;
  overflow-y: auto;
}

.avatar_box :hover {
  color: #5f6dae;
  text-decoration: underline;
}

.remain {
  padding: 0 5px;
}

.iffinish {
  border: #afb6d7 1px solid;
  background: #afb6d7;
}
.f_button {
  margin-top: 30px;
}
.commodity_index_box>a{
  background: #F7F7F7;
}
.margin-right_0{
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/safeguard.vue